import { isDev } from '@/utils/env';
export var DEFAULT_STORAGE_KEY_PREFIX = 'refresh-manager:';
export var DEFAULT_INTERVAL_CONFIG_KEY = isDev()
    ? 'BEM-test'
    : 'BEM-prod';
export var DEFAULT_INTERVAL_CONFIG_REFRESH_INTERVAL = 5 * 60 * 1000;
export var REFRESH_KEYS = {
    LOGGER: 'logger-clean',
};
